var HeaderGeneral = function(){

  var GENERAL_MEDIAQUERY_CHANGE = 'GENERAL_MEDIAQUERY_CHANGE';
  var GENERAL_MEDIAQUERY_CHECK = 'GENERAL_MEDIAQUERY_CHECK';

  var $ = jQuery;
  var currentMediaQuery = null;
  var mediaQueries = {
    'mobile': {
      min: 0,
      max: 660
    },
    'tablet': {
      min: 661,
      max: 1023
    },
    'desktop': {
      min: 1024,
      max: 40000
    }
  }

  function checkOnWindowResize(callback) {
    for (var param in mediaQueries) {
      if (mediaQueries.hasOwnProperty(param)) {
        if ( $(window).width() <= mediaQueries[param].max && $(window).width() >= mediaQueries[param].min ) {
          if (callback && typeof callback === 'function') {
            callback(param);
          }
          else {
            if (param !== currentMediaQuery || currentMediaQuery === null) {
              currentMediaQuery = param;
              Events.publish(GENERAL_MEDIAQUERY_CHANGE, [param]);
            }
          }
        }
      }
    }
  }

  function attachEvents() {
    $(window).resize(checkOnWindowResize);
  }

  function onReady() {
    attachEvents();

    // Events
    Events.subscribe(GENERAL_MEDIAQUERY_CHECK, checkOnWindowResize);

  }

  $(onReady);

}

HeaderGeneral();

(function () {

    var Header = function () {

        'use strict';

        var $ = jQuery;
        var $view;

        function init() {
            bind();
        }


        function onWindowScroll(e) {
            if ($(window).scrollTop() > 0) {
                $('#menu').addClass('sticky');
            }
            else if ($(window).scrollTop() >= 0) {
                $('#menu').addClass('sticky');
            }
        }

        function bindDesktopEvents() {
            $(window).on('scroll', onWindowScroll);
        }

        function unbindDesktopEvents() {
            // $('#menu').removeClass('sticky');
            $(window).off('scroll', onWindowScroll);
        }

        function bindMobileEvents() {
            $('#menu').find('.below').css('overflow', 'hidden');

            // Variables necesarias para calcular las posiciones
            var size = {
                width: null,
                height: null
            };
            var animationMenu = null;
            var animationLogo = null;
            var animationNav = null;

            $('#menu .burger').on('click', function (e) {
                e.preventDefault();
                var $menu = $('#menu');

                $(this).toggleClass('close');

                if (animationMenu !== null) {
                    animationMenu.stop();
                }

                if (animationNav !== null) {
                    animationNav.stop();
                }

                if (animationLogo !== null) {
                    animationLogo.stop();
                }

                // Recuperamos el tamaño del menú recogido
                if (size.width === null && size.height === null) {
                    size.width = $menu.width();
                    size.height = $menu.height();
                }

                $menu.toggleClass('opened');

                if ($menu.hasClass('opened') === true) {
                    // Entrada
                    $('body').css({
                        'overflow': 'hidden'
                    });

                    animationMenu = $menu.animate({
                        height: $(window).height()
                    }, 200, function () {
                        animationMenu = $menu.animate({
                            width: $(window).width()
                        }, 400, function () {

                        });
                        animationNav = $menu.find('div.nav-menu').animate({
                            right: 0,
                            opacity: 1,
                        }, 200, function () {
                            $('#menu').find('.below').css('overflow', 'auto');
                        });
                        animationLogo = $menu.find('div.logo').animate({
                            right: 0,
                            opacity: 1,
                        }, 200, function () {
                            $view.find('.language-selector').css('display', 'block');
                        });
                    });
                }
                else {
                    // Salida
                    $('body').css({
                        'overflow': 'auto'
                    });
                    $view.find('.language-selector').css('display', 'none');
                    animationNav = $menu.find('div.nav-menu').animate({
                        right: -30,
                        opacity: 0
                    }, 200, function () {
                        $('#menu').find('.below').css('overflow', 'hidden');
                    });
                    animationLogo = $menu.find('div.logo').animate({
                        right: -30,
                        opacity: 0
                    }, 200, function () { });
                    animationMenu = $menu.animate({
                        width: size.width
                    }, 200, function () {
                        $menu.animate({
                            height: size.height
                        }, 300, function () {

                        });
                    });
                }
            });

        }

        function unbindMobileEvents() {
            $('body').css('overflow', 'auto');
            $('#menu').removeAttr('style').removeClass('opened');
            $('#menu').find('.below').css('overflow', 'hidden');
            $('#menu').find('a.burger').removeAttr('style').removeClass('close');
            $('#menu').find('div.nav-menu').removeAttr('style');
            $('#menu').find('div.logo').removeAttr('style');
            $view.find('.language-selector').removeAttr('style');
            $('#menu .burger').off();
        }

        function bind() {
            $('#menu .language-selector').off().on('click', function (e) {
                if (!$(this).hasClass('opened')) {
                    e.preventDefault();
                    $(this).addClass('opened');
                }
                else {
                    $(this).removeClass('opened');
                }
            });
        }

        function mediaQueryChangeHeader(value) {
            if (value === 'mobile' || value === 'tablet') {
                unbindDesktopEvents();
                unbindMobileEvents();
                bindMobileEvents();
                bind();
            }
            else {
                unbindDesktopEvents();
                unbindMobileEvents();
                bindDesktopEvents();
                bind();
            }
        }

        $('#menu .search').on('click', function (e) {
            e.preventDefault();
            $("#search-container").addClass('open');
            $(".input-search-form").focus();
        });

        $(".input-search-form").keyup(function () {
            var s = $(".input-search-form").val();
            if ($(window).width() > 690) {
                if (s.length > 2) {
                    var data = {
                        'action': 'custom_search',
                        'search_term': s
                    };
                    var ajaxurl = '/wp-admin/admin-ajax.php';
                    var currentRequestAjax = null;
                    var currentRequestAjax = jQuery.ajax({
                        url: ajaxurl,
                        type: 'POST',
                        data: data,
                        beforeSend: function () {
                            // currentRequestAjax.abort();
                            // console.log("abort request"); 
                        },
                        success: function (response) {
                            if (response) {
                                $("#results").html('');
                                $("#results").html(response);
                                var height = $("#results").outerHeight(true) + 90;
                                $("#results-container").addClass('open');
                                console.log('height: ', height);
                                console.log('window height: ', jQuery(window).height() - jQuery('#search-container').height());
                                if (height > jQuery(window).height() - jQuery('#search-container').height()) {
                                    $('body').css({
                                        overflow: 'hidden'
                                    });
                                    height = jQuery(window).height() - jQuery('#search-container').height();
                                    $("#results-container").css({
                                        overflow: 'auto'
                                    });
                                }
                                else {
                                    $('body').css({
                                        overflow: 'auto'
                                    });
                                    $("#results-container").css({
                                        overflow: 'hidden'
                                    });
                                }
                                $("#results-container").css('height', height);
                            }
                        }
                    });

                } else {
                    $("#results-container").css('height', 0);
                    $("#results-container").removeClass('open');
                    $("#results").html('');
                }
            } else {
                $("#results-container").css('height', 0);
                $("#results-container").removeClass('open');
                $("#results").html('');
            }
        });

        this.searchFormOpen = function () {
            $("#search-container").addClass('open');
            $(".input-search-form").focus();
        }

        this.searchFormClose = function () {
            $("#search-container").removeClass('open');
            $("#results-container").css('height', 0);
            $("#results-container").removeClass('open');
            $("#results").html('');
            $(".input-search-form").val('');
            // Valores por defecto al body y a la caja de resultados
            $('body').css({
                overflow: 'auto'
            });
            $("#results-container").css({
                overflow: 'hidden'
            });
        }


        $view = $('#menu');
        init();

        $("#menu-menu .menu-icon a").click(this.searchFormOpen);
        $("#close-search-form").click(this.searchFormClose);

        // Subscribe events
        Events.subscribe('GENERAL_MEDIAQUERY_CHANGE', mediaQueryChangeHeader);
        // Trigger events
        Events.publish('GENERAL_MEDIAQUERY_CHECK', [mediaQueryChangeHeader]);
    }

    document.addEventListener('DOMContentLoaded', function () {
        window.Header = new Header();
    });
    
})();
